import React from 'react'

import { FieldArray } from 'formik'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import HELPTEXT from '../../../business-const/HelpText/HelpText'

import LABEL from '../../../business-const/Label/Label'

import NUMMIN from '../../../business-rules/NumMinMax/NumMin'

import NUMMAX from '../../../business-rules/NumMinMax/NumMax'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    CardGridDividerElementos,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridItem1,
    GridItem2,
    GridItem2xs4,
    GridItem3,
    GridItem3xs5,
    GridItem3xs6,
    GridItem6,
    GridItem6xs12,
    GridItem8,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    TextValidatorText,
    TextValidatorNumber,
    TextValidatorNumberRequired,
} from '../../../business-components/TextValidator/TextValidator'

import {
    TextFieldTextSelect,
} from '../../../business-components/TextField/TextFieldSelect'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import {
    IconButtonClearEntradaDados,
    IconButtonMaisInformacoes,
    IconButtonHelp,
} from '../../../business-components/IconButton/IconButton'

import {
    ButtonIncluirLinha
} from '../../../business-components/Button/Button'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import tipoMomentoTributacaoIRList from '../../../business-rules/List/tipoMomentoTributacaoIRList'

import {
    calculaGraficoPrevidenciaPrivada,
} from './PrevidenciaPrivadaServicePrevidenciaPrivada'

import {
    processaRegistrosDefaultIniciaisSimulacaoFinanceiraAporteRetiradaAnual,
    incrementaContPrevidenciaPrivadaSimulacao,
} from './PrevidenciaPrivadaServicePrevidenciaPrivadaSimulacao'

//import {
//    CustomizedDialogsPopupFundosPrevidenciaPrivada
//} from './PrevidenciaPrivadaComp'

import PrevidenciaPrivadaChart from '../estudo-chart/PrevidenciaPrivadaChart'

import PrevidenciaPrivadaFormPrevidenciaPrivadaSimulacaoAporte from
    './PrevidenciaPrivadaFormPrevidenciaPrivadaSimulacaoAporte'


    
const ProjetoVidaSonho = ({ handleChange, item, ind }) => {

    return (
        
        <CheckboxPadrao
            name={`objPrevidenciaPrivada.simulacao[${ind}].projetoVidaSonho`}
            label={LABEL.projetoVidaSonho}
            checked={item.projetoVidaSonho}
            onChange={handleChange}
        />
    )
}

const SimulacaoipoMomentoTributacaoIR = ({ handleChange, report, item, ind }) => {

    return (
        <>
            <GridItem3xs6>
                <TextFieldTextSelect
                    name={`objPrevidenciaPrivada.simulacao[${ind}].tipoMomentoTributacaoIR`}
                    label={LABEL.tipoMomentoTributacaoIR}
                    value={item.tipoMomentoTributacaoIR || ''}
                    onChange={handleChange}
                    list={tipoMomentoTributacaoIRList}
                    disabled={report}
                    report={report}
                />
            </GridItem3xs6>

            {(item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRComeCotas ||
            item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRPGBL ||
            item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRVGBL ||
            item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRResgate) && (
                <GridItem2xs4>
                    <TextValidatorNumberRequired
                        name={`objPrevidenciaPrivada.simulacao[${ind}].percIR`}
                        label={LABEL.percIR}
                        value={item.percIR === 0 ? 0 : item.percIR || ''}
                        onChange={handleChange}
                        numMin={NUMMIN.percIR}
                        numMax={NUMMAX.percIR}
                        disabled={report}
                        report={report}
                    />
                </GridItem2xs4>
            )}

            {(item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRVGBL ||
            item.tipoMomentoTributacaoIR === HARDCODE.tipoMomentoTributacaoIRResgate) && (
                <GridItem3xs5>
                    <TextValidatorNumberRequired
                        name={`objPrevidenciaPrivada.simulacao[${ind}].tempoMinimoEntreAportesResgatesCalculoIRAnos`}
                        label={LABEL.tempoMinimoEntreAportesResgatesCalculoIRAnos}
                        value={
                            item.tempoMinimoEntreAportesResgatesCalculoIRAnos === 0
                                ?
                                    0
                                :
                                    item.tempoMinimoEntreAportesResgatesCalculoIRAnos || ''
                        }
                        onChange={handleChange}
                        numMin={NUMMIN.tempoMinimoEntreAportesResgatesCalculoIRAnos}
                        numMax={NUMMAX.tempoMinimoEntreAportesResgatesCalculoIRAnos}
                        disabled={report}
                        report={report}
                    />
                </GridItem3xs5>
            )}
        </>
    )
}

const Simulacao = ({ values, handleChange, report, item, ind, popup }) => {

    return (
        <>
            <GridContainer>
                <GridItem2/>

                <GridItem2xs4>
                    <TextValidatorNumber
                        name={`objPrevidenciaPrivada.simulacao[${ind}].taxaJurosAnual`}
                        label={LABEL.taxaJurosAnual}
                        value={item.taxaJurosAnual === 0 ? 0 : item.taxaJurosAnual || ''}
                        onChange={handleChange}
                        numMin={NUMMIN.taxaNegativa}
                        numMax={NUMMAX.taxa}
                        disabled={report}
                        report={report}
                    />
                </GridItem2xs4>

                {popup
                    ?
                        <GridItem3xs6>
                            {/*
                            <CustomizedDialogsPopupFundosPrevidenciaPrivada
                                values={values}
                            />
                            */}
                        </GridItem3xs6>
                    :
                        <SimulacaoipoMomentoTributacaoIR
                            handleChange={handleChange}
                            report={report}
                            item={item}
                            ind={ind}
                        />
                }
            </GridContainer>

            {popup && (
                <GridContainer>
                    <GridItem2/>
                    
                    <SimulacaoipoMomentoTributacaoIR
                        handleChange={handleChange}
                        report={report}
                        item={item}
                        ind={ind}
                    />
                </GridContainer>
            )}

            <GridContainer>
                <GridItem2/>

                <GridItem3>
                    <ProjetoVidaSonho
                        handleChange={handleChange}
                        item={item}
                        ind={ind}
                    />
                </GridItem3>

                <GridItem1>
                    <IconButtonHelp
                        helpTitle={LABEL.projetoVidaSonho}
                        helpText={HELPTEXT.estudoPrevidenciaPrivadaProjetoVidaSonho}
                    />
                </GridItem1>
            </GridContainer>
        </>
    )
}



const PrevidenciaPrivadaFormPrevidenciaPrivadaSimulacao = ({ values, handleChange, estudo, report, indReport }) => {

    processaRegistrosDefaultIniciaisSimulacaoFinanceiraAporteRetiradaAnual(values)

    const GridItem6xs12SimulacaoParametros = report ? GridItem12 : GridItem6xs12
    const GridItem6xs12SimulacaoGrafico = report ? GridItem11 : GridItem6xs12

    return (
        <FieldArray name="objPrevidenciaPrivada.simulacao">
            {(arrayHelpers) => (
                <DivForm>
                    <DivForm>
                        {values.objPrevidenciaPrivada.simulacao?.map((item, ind) => {

                            const { graficoPrevidenciaPrivada, graficoPrevidenciaPrivadaAporte,
                                graficoPrevidenciaPrivadaRentabilidade, valorRetiradaMensalMaximaConsumirReservaAposentadoria,
                                    graficoPrevidenciaPrivadaConsumirReservaAposentadoria,
                                        valorRetiradaMensalMaximaPreservarReservaAposentadoria,
                                            graficoPrevidenciaPrivadaPreservarReservaAposentadoria, indexTotalAcumulado,
                                                valorEconomiaInventarioPrevidenciaPrivada} =
                                                    (!indReport && indReport !== 0) || ind === indReport
                                                        ?
                                                            calculaGraficoPrevidenciaPrivada(values, estudo, item,
                                                                item.aporte, false)
                                                        :
                                                            {}

                            return ((!indReport && indReport !== 0) || ind === indReport) && (
                                <div
                                    key={ind}
                                >
                                    {ind === 0 && !report && (
                                        <CardGridDividerElementos
                                            className='mt-5'
                                        />
                                    )}

                                    <GridContainer
                                        className={report ? 'mt-5' : 'mt-10 mb-5'}
                                    >
                                        <GridItem6xs12SimulacaoParametros>
                                            <GridContainer>
                                                <GridItem8>
                                                    <TextValidatorText
                                                        name={`objPrevidenciaPrivada.simulacao[${ind}].descricao`}
                                                        label={LABEL.simulacao}
                                                        value={item.descricao || ''}
                                                        onChange={handleChange}
                                                        tamMax={TAMMAX.descricaoSimulacao}
                                                        notToUpperCase={true}
                                                        disabled={report}
                                                        report={report}
                                                    />
                                                </GridItem8>

                                                {/*(!report || (report && (item.taxaJurosAnual || item.taxaJurosAnual === 0))) && (
                                                    <GridItem3>
                                                        
                                                    </GridItem3>
                                                )*/}

                                                <GridItem3>
                                                    {item.projetoVidaSonho && (
                                                        <ProjetoVidaSonho
                                                            handleChange={handleChange}
                                                            item={item}
                                                            ind={ind}
                                                        />
                                                    )}
                                                </GridItem3>

                                                {!report && (
                                                    <GridItem1
                                                        className='mt-3'
                                                    >
                                                        <GridContainer>
                                                            <GridItem6>
                                                                <CustomizedDialogsPopup
                                                                    maxWidth="md"
                                                                    popupTitle={LABEL.taxaJurosInflacao}
                                                                    tooltipTitle={LABEL.expandir}
                                                                    PopupButton={IconButtonMaisInformacoes}
                                                                    popupButtonDestaque={false}
                                                                    popupComponent={
                                                                        <Simulacao
                                                                            values={values}
                                                                            handleChange={handleChange}
                                                                            report={report}
                                                                            item={item}
                                                                            ind={ind}
                                                                            popup={true}
                                                                        />
                                                                    }
                                                                />
                                                            </GridItem6>
                                                            
                                                            <GridItem6>
                                                                <IconButtonClearEntradaDados
                                                                    onClick={() =>
                                                                        arrayHelpers.remove(ind)
                                                                    }
                                                                />
                                                            </GridItem6>
                                                        </GridContainer>
                                                    </GridItem1>
                                                )}
                                            </GridContainer>

                                            {(item.taxaJurosAnual || item.taxaJurosAnual === 0 || item.tipoMomentoTributacaoIR) && (
                                                <Simulacao
                                                    values={values}
                                                    handleChange={handleChange}
                                                    report={report}
                                                    item={item}
                                                    ind={ind}
                                                    popup={false}
                                                />
                                            )}

                                            <GridContainer>
                                                <GridItem12>
                                                    <PrevidenciaPrivadaFormPrevidenciaPrivadaSimulacaoAporte
                                                        values={values}
                                                        handleChange={handleChange}
                                                        report={report}
                                                        indAporte={ind}
                                                    />
                                                </GridItem12>
                                            </GridContainer>
                                        </GridItem6xs12SimulacaoParametros>

                                        <GridItem6xs12SimulacaoGrafico
                                            className={report ? 'mt--5' : 'mt--15'}
                                        >
                                            <PrevidenciaPrivadaChart
                                                 values={values}
                                                 estudo={estudo}
                                                 graficoPrevidenciaPrivada={graficoPrevidenciaPrivada}
                                                 graficoPrevidenciaPrivadaAporte={graficoPrevidenciaPrivadaAporte}
                                                 graficoPrevidenciaPrivadaRentabilidade={
                                                    graficoPrevidenciaPrivadaRentabilidade
                                                }
                                                valorRetiradaMensalMaximaConsumirReservaAposentadoria={
                                                    valorRetiradaMensalMaximaConsumirReservaAposentadoria
                                                }
                                                graficoPrevidenciaPrivadaConsumirReservaAposentadoria={
                                                    graficoPrevidenciaPrivadaConsumirReservaAposentadoria
                                                }
                                                valorRetiradaMensalMaximaPreservarReservaAposentadoria={
                                                    valorRetiradaMensalMaximaPreservarReservaAposentadoria
                                                }
                                                graficoPrevidenciaPrivadaPreservarReservaAposentadoria={
                                                    graficoPrevidenciaPrivadaPreservarReservaAposentadoria
                                                }
                                                indexTotalAcumulado={indexTotalAcumulado}
                                                projetoVidaSonho={item.projetoVidaSonho}
                                                report={report}
                                                simulacao={true}
                                                despesaDetutivelMensalPrevidenciaPrivadaCalc={''}
                                                valorEconomiaInventarioPrevidenciaPrivada={
                                                    valorEconomiaInventarioPrevidenciaPrivada}
                                            />
                                        </GridItem6xs12SimulacaoGrafico>
                                    </GridContainer>

                                    {!report && (
                                        <CardGridDividerElementos/>
                                    )}
                                </div>
                            )
                        })}
                    </DivForm>

                    {!report && (
                        <GridContainer>
                            <GridItem6xs12>
                                <ButtonIncluirLinha
                                    //align='right'
                                    label={LABEL.buttonIncluirSimulacao} 
                                    onClick={() => {
                                        incrementaContPrevidenciaPrivadaSimulacao(values)
                                        arrayHelpers.push({
                                            id: values.objPrevidenciaPrivada.contSimulacao,
                                            descricao: LABEL.simulacao + ' ' + values.objPrevidenciaPrivada.contSimulacao,
                                            aporte: [],
                                        })}
                                    }
                                />
                            </GridItem6xs12>
                        </GridContainer>
                    )}
                </DivForm>
            )}
        </FieldArray>
    )
}

export default PrevidenciaPrivadaFormPrevidenciaPrivadaSimulacao